import script from "./resize.vue?vue&type=script&lang=js"
export * from "./resize.vue?vue&type=script&lang=js"

import "./resize.vue?vue&type=style&index=0&id=6b92c59c&lang=css"

export default script